import { Controller } from "@api/config";
import type { IRequestConfig } from "@api/config";

import type { IMuteUserByIdRequest, ISendMessageRequest, IUnMuteUserByIdRequest } from "./request.types";
import type { TGetAllEmojisByModelResponse, TGetMutedUserListResponse } from "./response.types";

class ChatController extends Controller {
	public constructor() {
		super({ requestUrl: "models/chat/" });
	}

	/**@GET MUTED USER LIST */
	public async getMutedUserListAsync({ token }: IRequestConfig) {
		return this.get<TGetMutedUserListResponse[]>("base", "mute", { token });
	}

	/**@POST MUTE USER BY ID */
	public async muteUserByIdAsync({ token, userId, duration, reason }: IMuteUserByIdRequest) {
		return this.post<{ code: number; message: string }>(
			"mute",
			{
				userId,
				duration,
				reason,
			},
			{ token },
		);
	}

	/**@DELETE UNMUTE USER BY ID */
	public async unMuteUserByIdAsync({ token, userId }: IUnMuteUserByIdRequest) {
		return this.delete<{ code: number; message: string }>("mute", { data: { userId }, token });
	}

	/**@GET ALL EMOJIS BY MODEL */
	public async getAllEmojisByModelAsync({ token }: IRequestConfig) {
		return this.get<TGetAllEmojisByModelResponse[]>("base", "emoji", { token });
	}

	/** @POST SEND MESSAGE */
	public async sendMessage({ token, message, roomChatId, correlationId }: ISendMessageRequest) {
		return this.post<void>(
			"sendMessage",
			{
				message,
				roomChatId,
				correlationId,
			},
			{ token },
		);
	}
}

export const chatAPI = new ChatController();
